import { useEffect, useState } from "react";

const STEPS = [
  "Contacting NOAA / NASA satellites",
  "Fetching USF/NOAA AFAI seaweed belt",
  "Loading ocean currents + wind field",
  "Running ensemble drift forecast",
];

export default function Splash() {
  const [step, setStep] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setStep((s) => (s + 1) % STEPS.length), 1400);
    return () => clearInterval(t);
  }, []);

  return (
    <div
      data-testid="loading-splash"
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#0a1929] text-slate-100"
    >
      {/* soft radial glow behind the mark */}
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            "radial-gradient(circle at 50% 42%, rgba(41,171,226,0.18), transparent 55%)",
        }}
      />

      <div className="relative flex flex-col items-center px-6">
        <img
          src="/brand/mark.png"
          alt="SargaSentry"
          className="h-24 w-auto sm:h-28"
          style={{ animation: "splashFloat 3s ease-in-out infinite" }}
          data-testid="splash-mark"
        />
        <img
          src="/brand/sargasentry-dark.webp"
          alt="SargaSentry — Caribbean Early Warning"
          className="mt-5 h-8 w-auto sm:h-9"
        />
        <div className="mt-3 font-mono-tel text-sm font-bold tracking-[0.28em] text-cyan-300/90">
          SEE IT. TRACK IT. ACT EARLY.
        </div>

        {/* scanning progress bar */}
        <div className="relative mt-8 h-[3px] w-56 overflow-hidden rounded-full bg-white/10 sm:w-72">
          <div
            className="absolute inset-y-0 w-1/3 rounded-full bg-cyan-400"
            style={{ animation: "splashScan 1.4s ease-in-out infinite" }}
          />
        </div>

        <div className="mt-4 h-4 font-mono-tel text-[11px] tracking-wide text-slate-400">
          {STEPS[step]}
          <span className="text-cyan-400"> …</span>
        </div>
        <div className="mt-1 flex items-center gap-1.5 font-mono-tel text-[10px] font-bold text-emerald-400/90">
          <span className="live-dot h-1.5 w-1.5 rounded-full bg-emerald-400" /> 100% REAL SATELLITE DATA
        </div>
      </div>

      <style>{`
        @keyframes splashFloat { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-8px)} }
        @keyframes splashScan { 0%{left:-33%} 100%{left:100%} }
      `}</style>
    </div>
  );
}
